import React from 'react'
import './style.css'

const PNotFound = () => {
  return <h1> NOT FOUND!!! :P</h1>
}

export default PNotFound
